"use client"

import { GoogleTagManager } from "@next/third-parties/google"
import dynamic from "next/dynamic"

// 动态导入非首屏必需的组件，优化首屏渲染速度
// 这些组件在页面交互后加载，不影响首屏渲染
const CookieConsentCmp = dynamic(() => import("@repo/ui/cookie-consent"), {
	ssr: false,
})

const PageTracker = dynamic(() => import("@repo/ui").then((mod) => ({ default: mod.PageTracker })), {
	ssr: false,
})

/**
 * 延迟加载的非首屏组件容器
 * 这些组件在页面交互后加载，优化首屏性能
 */
export default function DeferredComponents() {
	return (
		<>
			<CookieConsentCmp />
			<PageTracker />
		</>
	)
}

/**
 * Google Tag Manager 组件
 * 放在 <body> 内渲染，避免二次动态加载导致注入延后
 */
export function DeferredGoogleTagManager({ gtmId }: { gtmId: string }) {
	return <GoogleTagManager gtmId={gtmId} />
}
